const rollNumberActions = {
  GET_EXAM_DETAILS_WITH_COURSEID: "GET_EXAM_DETAILS_WITH_COURSEID",
  SET_EXAM_DETAILS_WITH_COURSEID: "SET_EXAM_DETAILS_WITH_COURSEID",

  GET_BATCH_CANDIDATES: "GET_BATCH_CANDIDATES",
  SET_BATCH_CANDIDATES: "SET_BATCH_CANDIDATES",

  GET_DOWNLOAD_ROLL_NO_DATA: "GET_DOWNLOAD_ROLL_NO_DATA",
  SET_DOWNLOAD_ROLL_NO_DATA: "SET_DOWNLOAD_ROLL_NO_DATA",

  GENERATE_ROLL_NUMBER: "GENERATE_ROLL_NUMBER",
  RESET_ROLL_NUMBER_GENERATION: "RESET_ROLL_NUMBER_GENERATION",

  SAVE_ROLL_NUMBER: "SAVE_ROLL_NUMBER",

  DELETE_ROLL_NUMBER: "DELETE_ROLL_NUMBER",

  FETCH_ROLL_NUMBER: "FETCH_ROLL_NUMBER",
  SET_FETCHED_ROLL_NO_DATA: "SET_FETCHED_ROLL_NO_DATA",

  RETRY_ROLL_NUMBER: "RETRY_ROLL_NUMBER",

  GET_ROLL_NUMBER_STATUS: "GET_ROLL_NUMBER_STATUS",
  SET_ROLL_NUMBER_STATUS: "SET_ROLL_NUMBER_STATUS",
};
export default rollNumberActions;
